<template>
    <div class="hide-for-group-options">
        <div v-for="(option, index) in options" :key="index"
            :class="value.includes(option.value) ? 'active hide-for-group-badge' : 'hide-for-group-badge'">
            <span v-if="toggleVisibilityUrl && !mandatoryHideForGroup.includes(option.value)"
                class="change-visibility"
                @click="changeVisibility(option.value)">
                {{ option.text }}
            </span>
            <span v-else-if="isToggleFleetManagerVisibilityButton(option.value)" class="change-visibility"
                @click="emitFleetManagerVisibilityToggled">
                {{ option.text }}
            </span>
            <span v-else>{{ option.text }}</span>
        </div>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import LoadingScopesEnum from '@js/enums/LoadingScopesEnum';
    import RoleGroupEnum from '@js/enums/RoleGroupEnum';

    const container = Container.getInstance();
    const ajaxService = container.getAjaxService();
    const flashMessenger = container.getFlashMessenger();

    export default {
        props: {
            value: {
                type: Array,
                default: null,
            },
            options: {
                type: Array,
                default: null,
            },
            toggleVisibilityUrl: {
                type: String,
                default: null,
            },
            canToggleFleetManagerVisibility: {
                type: Boolean,
                default: false,
            },
            mandatoryHideForGroup: {
                type: Array,
                default: () => [],
            },
        },
        emits: ['reload', 'remove-loading', 'fleet-manager-visibility-toggled'],
        data() {
            return {
                isLoading: false,
            };
        },
        methods: {
            changeVisibility(toggleValue) {
                if (this.isLoading) {
                    return;
                }

                this.isLoading = true;

                const payload = {
                    data: {
                        attributes: {
                            toggleValue: toggleValue,
                        },
                    },
                }

                ajaxService.postJson(this.toggleVisibilityUrl, payload)
                    .then(() => {
                        this.$emit('reload', LoadingScopesEnum.INFO_CARD);
                        flashMessenger.addSuccess('Die Sichtbarkeit wurde erfolgreich geändert.');
                        this.isLoading = false;
                    })
                    .catch(() => {
                        this.$emit('remove-loading', LoadingScopesEnum.INFO_CARD);
                    });
            },
            isToggleFleetManagerVisibilityButton(optionValue) {
                return this.canToggleFleetManagerVisibility && optionValue === RoleGroupEnum.FLEET_MANAGER;
            },
            emitFleetManagerVisibilityToggled() {
                this.$emit('fleet-manager-visibility-toggled');
            },
        },
    }
</script>
